import React from "react";
import PropTypes from "prop-types";
import ProductPricesTable from "../ProductPricesTable";
import { WHITE_TAB_STYLES } from "components/Tabs";
import Tabs from "components/Tabs";
import { useFormikContext } from "formik";
import HoverIconButton from "components/HoverIconButton";
import cloneDeep from "lodash/cloneDeep";
import ProductPricePrimaryPicker from "../ProductPricePrimaryPicker";
import { findIndexForModel } from "utils/data";
import { separateNewAndExistingPrices } from "utils/pricing";
import classnames from "classnames";
import Analytics, {
  REMOVE_PRODUCT,
  TEMPLATE_PAGE_BUILDER
} from "utils/analytics";
import CreatePriceForm from "components/CheckoutPricePicker/CreatePriceForm";
import { PRICE_FIELDS } from "utils/constants/fields";

const ProductPricesController = (props) => {
  const { values, setFieldValue } = useFormikContext();
  const { context } = values.form;
  const commonProps = {
    id: props.id,
    isLast: props.isLast,
    isFirst: props.isFirst,
    name: props.name,
    productIndex: props.productIndex,
    tracking: props.tracking
  };
  const { newPrices, existingPrices } = separateNewAndExistingPrices(
    props.prices
  );

  /**
   * Get state path to price by id
   */
  const priceIndex = values.products.findIndex(
    (product) => product.id === props.id
  );
  const productIndex = findIndexForModel(props, values.products);
  const pricePath = `products[${productIndex}].prices[${priceIndex}]`;

  const multipleTabs = existingPrices.length;

  const tabs = [
    {
      name: "New",
      id: "new",
      node:
        context === TEMPLATE_PAGE_BUILDER ? (
          <div
            className={classnames({
              "pv3 pl3 pr2": multipleTabs
            })}
          >
            <ProductPricesTable
              {...commonProps}
              prices={newPrices}
              insideTabs={multipleTabs}
            />
          </div>
        ) : (
          <div className="pa3 ba b--black-10 br2 w-100">
            <CreatePriceForm
              name={pricePath}
              fields={[
                PRICE_FIELDS.FORMATTED_PRICE,
                PRICE_FIELDS.SCHEDULE,
                PRICE_FIELDS.TAX_BEHAVIOR
              ]}
            />
          </div>
        )
    }
  ];
  if (multipleTabs) {
    tabs.unshift({
      name: "Prices",
      id: "prices",
      node: (
        <div
          className={classnames({
            pa3: multipleTabs
          })}
        >
          <ProductPricePrimaryPicker {...commonProps} prices={existingPrices} />
        </div>
      )
    });
  }

  const tabProps = {
    minWidth: false,
    equalWidth: false,
    pathPrefix: `${props.productIndex}`,
    customStyles: WHITE_TAB_STYLES,
    customClasses: {
      content: {
        container: multipleTabs
          ? "w-100 center bl bb br br2 br--bottom hairline-1"
          : "w-100 center"
      },
      tabs: {
        list:
          "list ma0 pa0 nowrap center overflow-x-auto absolute top-0 left-0 right-0 ph0"
      }
    },
    tabs
  };

  return (
    <div className="w-100 flex flex-column">
      <div className="flex flex-row items-center  pb3">
        <div className="flex items-center justify-center">
          <HoverIconButton
            type="close"
            tooltip="Remove product"
            onClick={() => {
              Analytics.track(REMOVE_PRODUCT, props.tracking);
              const updatedProducts = cloneDeep(values.products);
              updatedProducts.splice(productIndex, 1);
              setFieldValue("products", updatedProducts);
            }}
          />
        </div>
        <div className="f3 pl2 fw5">{props.name}</div>
      </div>
      <Tabs {...tabProps} />
    </div>
  );
};

ProductPricesController.propTypes = {
  isLast: PropTypes.bool,
  isFirst: PropTypes.bool,
  id: PropTypes.string,
  name: PropTypes.string,
  prices: PropTypes.array,
  tracking: PropTypes.object,
  productIndex: PropTypes.number
};

export default ProductPricesController;
